import Vue from 'vue'
import {
  Form,
  FormItem,
  Input,
  DatePicker,
  Select,
  Option,
  Button,
  Row,
  Col,
  Upload,
  Link,
  Tree,
  Icon,
  Image,
  Dialog,
  Loading,
} from 'element-ui';
import '@/assets/styles/index.scss' // global css
import App from './App.vue'
import router from './router'
import store from './store'
// 文件上传组件
import FileUpload from "@/components/FileUpload"

Vue.component('FileUpload', FileUpload)
import IosSelectFix from '@/directives/iosSelectFix'

Vue.prototype.$ELEMENT = { size: 'medium' };
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(DatePicker);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Link);
Vue.use(Tree);
Vue.use(Icon);
Vue.use(Image);
Vue.use(Dialog);
Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;

// 修复 iOS web-view 中 el-select 需要点击两次的问题
Vue.use(IosSelectFix)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
